/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { theme } from "styles";
import Popup from "components/ui/Popup";
import Modal from "components/ui/Modal";
import Text from "components/ui/Text";
import Button from "components/entrance/Button";
import {
  TermsServiceComponent,
  TermsPrivacyAgreeComponent,
  TermsMarketingComponent,
  FirstInInfo,
} from "components/entrance/signup";
import Splash from "assets/icons/splash.svg";
import TermsCheckOn from "assets/icons/terms_check_on.svg";
import TermsCheckOff from "assets/icons/terms_check_off.svg";
// redux
import {
  setUseTermYN,
  setPrivacyYN,
  setMarketingYN,
} from "redux/slices/signup/signupSlice";
import { updatePartnerInfo } from "redux/slices/partner/partnerSlice";
import { checkForNewNotifications } from "redux/slices/notifications/notificationsSlice";
// hooks
import { api } from "utils/api";
import { applyHighlight } from "utils/applyHighlight";

const Entrance = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openFirstInfo, setOpenFirstInfo] = useState(false);
  const [arrChecked, setArrChecked] = useState([false, false, false]);

  useEffect(() => {
    const onBoarding = window.localStorage.getItem("onBoarding");
    if (!onBoarding) {
      setOpenFirstInfo(true);
    }

    const tokenData = window.localStorage.getItem("accessToken");
    if (tokenData) {
      api.defaults.headers.common["Authorization"] = `Bearer ${tokenData}`;
      dispatch(updatePartnerInfo());
      dispatch(checkForNewNotifications());
      navigate("/home");
    }
  }, []);

  const handleClickChecked = (i) => {
    if (i === 3) {
      if (arrChecked.filter((v) => v).length === 3) {
        setArrChecked([false, false, false]);
      } else {
        setArrChecked([true, true, true]);
      }
      return;
    }
    setArrChecked((previousValue) =>
      previousValue.map((v, idx) => (i === idx ? !v : v))
    );
    return;
  };

  const handleClickDone = () => {
    arrChecked[0] ? dispatch(setUseTermYN("Y")) : "";
    arrChecked[1] ? dispatch(setPrivacyYN("Y")) : "";
    arrChecked[2] ? dispatch(setMarketingYN("Y")) : "";
    navigate("signup");
  };

  return (
    <Wrapper viewportHeight={window.innerHeight}>
      <WrapperTop>
        <Img src={Splash} alt="back" width="60px" height="60px" />
        <DividerMain viewportHeight={window.innerHeight} />
        <Text
          display="block"
          color="white"
          fontSize="32px"
          fontWeight="700"
          lineHeight="42px"
          css={css`
            margin-left: 20px;
            margin-bottom: 16px;
          `}
        >
          센터의 성공
          <br />
          바디코디와 함께
        </Text>
        <Text
          display="block"
          color="#C9DBFF"
          fontSize="18px"
          fontWeight="400"
          lineHeight="22px"
          css={css`
            margin-left: 20px;
          `}
        >
          사장님, 센터 관리 시작해 볼까요?
        </Text>
      </WrapperTop>
      <div>
        <Button
          color="white"
          background="primary100"
          onClick={() => setOpen(true)}
        >
          <Text
            color="white"
            fontSize="18px"
            fontWeight="600"
            lineHeight="24px"
          >
            관리자앱 회원가입
          </Text>
        </Button>

        <Button
          color="gray80"
          background="white"
          onClick={() => navigate("signin")}
        >
          <Text
            color="gray100"
            fontSize="18px"
            fontWeight="600"
            lineHeight="24px"
          >
            로그인
          </Text>
        </Button>
      </div>

      <Popup open={open} onClose={setOpen}>
        <WrapperPopup>
          <Text
            display="block"
            fontWeight="600"
            lineHeight="20px"
            css={css`
              margin-bottom: 18px;
            `}
          >
            이용약관동의
          </Text>
          <WrapperText onClick={() => handleClickChecked(3)}>
            <Text fontSize="14px" fontWeight="600" lineHeight="20px">
              전체 약관에 동의합니다.
            </Text>
            <Img
              src={
                arrChecked.filter((v) => v).length === 3
                  ? TermsCheckOn
                  : TermsCheckOff
              }
              alt="back"
              width="20px"
              height="20px"
            />
          </WrapperText>
          <Divider />
          <WrapperText>
            <Text
              color="gray80"
              fontSize="14px"
              lineHeight="20px"
              onClick={() => {
                Modal(
                  <TermsServiceComponent
                    onClose={() => {
                      Modal();
                    }}
                  />
                );
              }}
            >
              [필수]&nbsp;
              <span style={{ textDecoration: "underline" }}>
                {applyHighlight("(보기)", "서비스 이용약관 동의 (보기)")}
              </span>
            </Text>
            <div onClick={() => handleClickChecked(0)}>
              <Img
                src={arrChecked[0] ? TermsCheckOn : TermsCheckOff}
                alt="back"
                width="20px"
                height="20px"
              />
            </div>
          </WrapperText>
          <WrapperText>
            <Text
              color="gray80"
              fontSize="14px"
              lineHeight="20px"
              onClick={() => {
                Modal(
                  <TermsPrivacyAgreeComponent
                    onClose={() => {
                      Modal();
                    }}
                  />
                );
              }}
            >
              [필수]&nbsp;
              <span style={{ textDecoration: "underline" }}>
                {applyHighlight("(보기)", "개인정보 수집 및 이용동의 (보기)")}
              </span>
            </Text>
            <div onClick={() => handleClickChecked(1)}>
              <Img
                src={arrChecked[1] ? TermsCheckOn : TermsCheckOff}
                alt="back"
                width="20px"
                height="20px"
              />
            </div>
          </WrapperText>
          <WrapperText>
            <Text
              color="gray80"
              fontSize="14px"
              lineHeight="20px"
              onClick={() => {
                Modal(
                  <TermsMarketingComponent
                    onClose={() => {
                      Modal();
                    }}
                  />
                );
              }}
            >
              [선택]&nbsp;
              <span style={{ textDecoration: "underline" }}>
                {applyHighlight("(보기)", "마케팅 정보/수신 동의 (보기)")}
              </span>
            </Text>
            <div onClick={() => handleClickChecked(2)}>
              <Img
                src={arrChecked[2] ? TermsCheckOn : TermsCheckOff}
                alt="back"
                width="20px"
                height="20px"
              />
            </div>
          </WrapperText>
          <Button
            color={arrChecked[0] && arrChecked[1] ? "white" : "disable"}
            background={arrChecked[0] && arrChecked[1] ? "primary100" : "gray5"}
            onClick={
              arrChecked[0] && arrChecked[1] ? handleClickDone : () => {}
            }
            css={css`
              margin-top: 24px;
            `}
          >
            확인
          </Button>
        </WrapperPopup>
      </Popup>

      <Popup
        open={openFirstInfo}
        onClose={setOpenFirstInfo}
        padding="0"
        isRadius={false}
      >
        <FirstInInfo onClose={setOpenFirstInfo} />
      </Popup>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 60px 20px 64px;
  padding-top: ${(props) => (props.viewportHeight > 700 ? "60px" : "15%")};
  padding-bottom: ${(props) => (props.viewportHeight > 700 ? "64px" : "10%")};
  background: #0f2859;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const WrapperTop = styled.div`
  flex: 1;
`;

const WrapperPopup = styled.div`
  margin-bottom: 17px;
`;

const Img = styled.img`
  display: inline-block;
  margin-left: 10px;
`;
const DividerMain = styled.div`
  border-top: 1px solid #2e4779;
  margin: 24px 18px 30px;
  margin-top: ${(props) => (props.viewportHeight > 700 ? "24px" : "12px")};
  margin-bottom: ${(props) => (props.viewportHeight > 700 ? "30px" : "18px")};
`;

const WrapperText = styled.div`
  display: flex;
  justify-content: space-between;
  div {
    padding-left: 20px;
  }
  & + & {
    margin-top: 18px;
  }
`;

const Divider = styled.div`
  border-top: 1px solid ${theme.colors["line20"]};
  margin: 18px 0;
`;

export default Entrance;
